export class BoardMediaSliderListener {
    public static bindWindowResize(onResize: () => void): void {
        globalThis.addEventListener("resize", onResize, { passive: true });
    }

    public static observeAreaMutations(target: HTMLElement, onMutate: () => void): MutationObserver {
        const observer = new MutationObserver(() => {
            onMutate();
        });

        observer.observe(target, {
            childList: true,
            subtree: true,
        });

        return observer;
    }

    public static bindClick(target: HTMLElement, onClick: () => void): void {
        target.addEventListener("click", onClick);
    }

    public static bindLoadCapture(target: HTMLElement, onLoad: () => void): void {
        target.addEventListener("load", onLoad, true);
    }
}
